module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrcode-card"
  }, [_c('div', {
    staticClass: "qrc-image",
    style: ('background-image: url(\'' + _vm.qrcodeSrc + '\')')
  }), _vm._v(" "), _c('p', [_vm._v("扫描二维码，查看手机版")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-72b92e60", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-72b92e60"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/pack/qrcode-card.vue
// module id = 1078
// module chunks = 1